var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormControl, Validators } from '@angular/forms';
import { ORGANISATION_ROLES } from '@careapp/core';
import { ConstantSelector } from '../constant-selector.component';
var RoleSelectComponent = /** @class */ (function (_super) {
    __extends(RoleSelectComponent, _super);
    function RoleSelectComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formControl = new FormControl('', [Validators.required]);
        _this._defaultOptions = ORGANISATION_ROLES;
        _this.options = _this._defaultOptions;
        return _this;
    }
    return RoleSelectComponent;
}(ConstantSelector));
export { RoleSelectComponent };
